import { cva } from 'class-variance-authority';

// Shared card layout — re-exported under the deck-scoped names DeckCard's
// files already use (see ../cards/cardVariants for the definitions).
export type { CardVariantProps as DeckCardVariantProps } from '../cards/cardVariants';
export {
  CARD_SURFACE_ALPHA,
  cardBodyVariants as deckCardBodyVariants,
  cardBorderClass as deckCardBorderClass,
  cardTitleVariants as deckCardTitleVariants,
  cardVariants as deckCardVariants,
} from '../cards/cardVariants';

/**
 * Grid cover tile — DeckCard-specific (folders/study-groups use their own
 * folder tile). Fills the WHOLE inner box, extending under the body panel.
 * With media it clips the document preview; without media it's the emoji
 * tile whose bg / border tints are computed from the deck colour (inline
 * style — see DeckCard.tsx). Emoji padding pt-3 / pb-12 (Figma 12 / 48)
 * lifts the emoji so it centres in the VISIBLE strip above the body.
 */
export const deckCardCoverVariants = cva(
  // Hover lift (web): ONLY the preview tile shifts up — the card container,
  // body panel and border stay put. The card Pressable carries `group/card`.
  'w-full flex-1 items-center justify-center overflow-hidden rounded-[20px] border ' +
    // Transition unprefixed so the native press-lift animates like web hover.
    'transition-transform duration-200 ease-out web:group-hover/card:-translate-y-1',
  {
    variants: {
      media: {
        true: 'border-secondary-200 web:shadow-card-cover',
        false: 'web:shadow-card-tile',
      },
      size: { compact: '', expanded: '' },
    },
    // Emoji paddings (no-media only) — pb clears the body panel so the
    // emoji centres where the Figma puts it. Compact: pt 12 / pb 72 / px 12
    // (5714:28959). Expanded: the emoji box sits at y=34.5 h=52 in the 209
    // tile (5656:17002), centre 60.75 → pt 16 + pb 104 centres the 55px
    // line at 60.5.
    compoundVariants: [
      { media: false, size: 'compact', class: 'px-3 pb-[72px] pt-3' },
      { media: false, size: 'expanded', class: 'px-4 pb-[104px] pt-4' },
    ],
    defaultVariants: { media: false, size: 'compact' },
  },
);
